import postal from 'postal/lib/postal.lodash';
import PubSub from './index';
import Global from '../../global';

export function getMockDefinitionChannels() {
  Global.logger.warn(
    'COULDNT FIND ANY CHANNELS ON INIT FUNCTION --- started with mocked session channel'
  );

  const session = postal.channel('sessionchannel');
  session.topics = {
    heartBeat: 'heartBeat',
    inactivityTimeout: 'inactivityTimeout'
  };

  session.publish = (topic, headers, data) => {
    postal.publish({
      channel: 'sessionchannel',
      topic: topic,
      headers: headers,
      data: data
    });
  };

  const userinteraction = postal.channel('userinteractionchannel');
  userinteraction.topics = {
    BurgerMenu_Toggle: 'BurgerMenu_Toggle'
  };

  userinteraction.publish = (topic, headers, data) => {
    postal.publish({
      channel: 'userinteractionchannel',
      topic: topic,
      headers: headers,
      data: data
    });
  };

  const vendor = postal.channel('vendorchannel');
  vendor.topics = {
    SystemActivity_PageRendered: 'SystemActivity_PageRendered'
  };

  vendor.publish = (topic, headers, data) => {
    postal.publish({
      channel: 'vendorchannel',
      topic: topic,
      headers: headers,
      data: data
    });
  };

  const wallet = postal.channel('walletchannel');
  wallet.topics = {
    PlayerAction_BetSucceeded: 'PlayerAction_BetSucceeded'
  };

  wallet.publish = (topic, headers, data) => {
    postal.publish({
      channel: 'walletchannel',
      topic: topic,
      headers: headers,
      data: data
    });
  };

  const crosssell = postal.channel('crosssellchannel');
  crosssell.topics = {
    CTA_CasinoClient_Open: 'CTA_CasinoClient_Open',
    CTA_LiveDealer_Open: 'CTA_LiveDealer_Open',
    CTA_Vegas_Open: 'CTA_Vegas_Open',
    CTA_PokerClient_Open: 'CTA_PokerClient_Open'
  };

  crosssell.publish = (topic, headers, data) => {
    postal.publish({
      channel: 'crosssellchannel',
      topic: topic,
      headers: headers,
      data: data
    });
  };

  const crm = postal.channel('crmchannel');
  crm.topics = {
    CTA_RICH_Open: 'CTA_RICH_Open',
    CTA_ExternalLink_Open: 'CTA_ExternalLink_Open'
  };

  crm.subscribe(crm.topics.CTA_ExternalLink_Open, data => {
    window.location.href = data.Url;
  });

  crm.publish = (topic, headers, data) => {
    postal.publish({
      channel: 'crmchannel',
      topic: topic,
      headers: headers,
      data: data
    });
  };

  const player = postal.channel('playerchannel');
  player.topics = {
    CTA_NRS_Open: 'CTA_NRS_Open',
    CTA_Login_Request_Submit: 'CTA_Login_Request_Submit',
    CTA_MyAccount_Open: 'CTA_MyAccount_Open',
    CTA_Logout_Request_Submit: 'CTA_Logout_Request_Submit'
  };

  player.publish = (topic, headers, data) => {
    postal.publish({
      channel: 'playerchannel',
      topic: topic,
      headers: headers,
      data: data
    });
  };

  const payments = postal.channel('paymentschannel');
  payments.topics = {
    CTA_Cashier_Open: 'CTA_Cashier_Open'
  };

  payments.publish = (topic, headers, data) => {
    postal.publish({
      channel: 'paymentschannel',
      topic: topic,
      headers: headers,
      data: data
    });
  };

  return {
    channels: {
      session: session,
      userinteraction: userinteraction,
      vendor: vendor,
      wallet: wallet,
      crosssell: crosssell,
      crm: crm,
      player: player,
      payments: payments
    }
  };
}

export function publishTopicOnChannel(
  topicName,
  pubSubChannel,
  calledFromMethod,
  data = null,
  headers
) {
  // used console instead of logger because tests are failing with logger
  // as it's not initialized at tests run time
  const PubSubInstance = PubSub.get();
  if (PubSubInstance) {
    const channel = PubSubInstance.channels[pubSubChannel];
    if (channel) {
      const topic = channel.topics[topicName];
      if (topic) {
        PubSub.get().publishTopicToChannel(channel, topic, data, headers);

        Global.logger.info(
          'Published message with topic ' +
            topicName +
            ' on channel ' +
            pubSubChannel +
            ' with this payload ' +
            JSON.stringify(data) +
            ' and the following headers ' +
            JSON.stringify(headers)
        );
      } else {
        Global.logger.warn(
          'ON Publish Could not find TOPIC ' + topicName + ' on channel ',
          pubSubChannel
        );
      }
    } else {
      Global.logger.warn(
        'ON Publish Could not find channel ' +
          pubSubChannel +
          ' on ' +
          calledFromMethod
      );
    }
  }
}

export function subscribeToTopic(
  channelName,
  topicName,
  callbackFunction,
  calledFromMethod
) {
  const PubSubInstance = PubSub.get();
  if (PubSubInstance) {
    const channel = PubSubInstance.channels[channelName];
    if (channel) {
      const topic = channel.topics[topicName];
      if (topic) {
        try {
          topic.subscribe(callbackFunction);
        } catch (error) {
          Global.logger.error(
            `Subscribe callback to topic ${topicName} of channel ${channelName} failed. ${error}`
          );
        }

        Global.logger.info(
          'Received message for topic ' +
            topicName +
            ' on channel ' +
            channelName
        );
      } else {
        Global.logger.warn(
          'Couldnt find TOPIC ' + topicName + ' on channel ',
          channelName
        );
      }
    } else {
      Global.logger.warn(
        'Couldnt find channel ' + channelName + ' on ' + calledFromMethod
      );
    }
  }
}
